import {
  Flex,
  Spin,
} from 'antd'
import React, { useState } from 'react'
import useAsync from 'react-use/lib/useAsync'

import { ReportsPageProps } from '@/components/feature/analytics/hooks/use-report-search'
import { FeatureKey } from '@/constants/feature-key'
import { readFansReport } from '@/redux/fans-reports'
import { selectFeatureTimezone } from '@/redux/global-selector'
import {
  createAppSelector,
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'

import FansReportsNewFans from './fans-reports-new-fans'
import FansReportsTotalFans
  from './fans-reports-total-fans'

export interface FansReportsForCreatorFansProps extends ReportsPageProps {
  creatorId: number
}

const selector = createAppSelector(
  [(state) => state.fansReports.fansReport, selectFeatureTimezone],
  (fansReport, { featureTimezone }) => ({
    fansReport,
    featureTimezone,
  }),
)

export default function FansReportsForCreatorFans({
  creatorId,
  searchValues,
}: FansReportsForCreatorFansProps) {
  const { fansReport, featureTimezone } = useAppSelector(selector)
  const dispatch = useAppDispatch()
  const [loadingFansReport, setLoadingFansReport] = useState(false)

  const { startAt, endAt, period } = searchValues

  useAsync(async () => {
    setLoadingFansReport(true)
    await dispatch(readFansReport({
      startAt,
      endAt,
      period,
      creatorId,
      permissionKey: FeatureKey.FansReports,
    }))
    setLoadingFansReport(false)
  }, [dispatch, creatorId, startAt, endAt, period])

  return (
    <Spin spinning={loadingFansReport}>
      <Flex vertical gap={16}>
        <FansReportsNewFans {...fansReport} featureTimezone={featureTimezone} />
        <FansReportsTotalFans {...fansReport} />
      </Flex>
    </Spin>
  )
}
